import React, { useEffect, useState  } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import GuessPassword from '../../components/GuessPassword';

import friendlybook from '../../assets/images/friendlybook.png';

function Module15() {

  // Page nav control
  const { canContinue, setCanContinue } = usePageControl();
  
  useEffect(() => {
    setCanContinue(false);
  }, [setCanContinue]);

  const handleSuccess = () => {
    setCanContinue(true);
  };


// Timer
const { timeRemaining, formatTime, isRunning } = useTimer();

  // Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 


  return (
    <div id="module-15" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div id="box-wrapper-fb">
                   
                            <img src={friendlybook} className="friendlybook-logo" alt="FriendlyBook logo"/>
                            <h1>Authenticate Login</h1>
                            <GuessPassword
                                hashedAnswer="49eb1b00fdf4de28d022a090ec9164836c140f28795dfb5b727f7373d8c86ca5" // SHA-256
                                onSuccess={handleSuccess}
                            >
                                <p className="text-center">To validate this login, please enter the code from your authenticator app below.</p>
                            </GuessPassword>
    
                    </div>
                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module15;
